import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb20 from '../images/thumb_20.jpg';
import thumb21 from '../images/thumb_21.jpg';
import thumb22 from '../images/thumb_22.jpg';
import thumb23 from '../images/thumb_23.jpg';

import img20 from '../images/20.png';
import img21 from '../images/21.png';
import img22 from '../images/22.png';
import img23 from '../images/23.png';

import {Modal} from 'react-bootstrap';
import "./modal.css";


export default function Glaucoma(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img20);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Glaucoma
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb20}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Glaucoma Progression</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Glaucoma - Progression",img20)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb21}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Open Angle</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Glaucoma - Open Angle",img21)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb22}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Closed Angle</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Glaucoma - Closed Angle",img22)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb23}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Narrow Angle</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Glaucoma - Narrow Angle",img23)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 



                    </div>
                </div>
            </div> 
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>            
        </>
    )
}